import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const BusIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 60 72" {...props}>
      <defs>
        <path
          id="bus-a"
          d="M45.198,51.961 C45.198,49.76 47.067,47.976 49.372,47.976 C51.677,47.976 53.546,49.76 53.546,51.961 C53.546,54.162 51.677,55.946 49.372,55.946 C47.067,55.946 45.198,54.162 45.198,51.961 Z M6.605,40.005 L53.513,40.005 L53.513,21.065 L6.605,21.065 L6.605,40.005 Z M10.779,55.946 C8.474,55.946 6.605,54.162 6.605,51.961 C6.605,49.76 8.474,47.976 10.779,47.976 C13.084,47.976 14.953,49.76 14.953,51.961 C14.953,54.162 13.084,55.946 10.779,55.946 Z M21.652,7.948 L38.347,7.948 C39.961,7.948 41.269,9.197 41.269,10.738 C41.269,12.278 39.961,13.527 38.347,13.527 L21.652,13.527 C20.038,13.527 18.73,12.278 18.73,10.738 C18.73,9.197 20.038,7.948 21.652,7.948 Z M59.999,8.358 C59.99,5.506 57.745,4.135 54.694,3.188 C54.694,3.188 44.756,0 30.059,0 C15.362,0 5.304,3.188 5.304,3.188 C2.295,4.108 0.009,5.506 0,8.358 L0,8.374 L0,21.065 L0,40.006 L0,41.766 L0,54.25 L0,57.6 L0,60.05 C0,62.25 1.875,64.05 4.166,64.05 L6.605,64.05 L6.605,70.406 C6.605,71.283 7.356,72 8.275,72 L13.283,72 C14.201,72 14.953,71.283 14.953,70.406 L14.953,64.03 L45.198,64.03 L45.198,70.406 C45.198,71.283 45.949,72 46.867,72 L51.876,72 C52.794,72 53.546,71.283 53.546,70.406 L53.546,64.05 L55.833,64.05 C55.904,64.05 55.969,64.033 56.039,64.03 L56.088,64.03 L56.094,64.03 C56.098,64.03 56.108,64.024 56.113,64.023 C58.273,63.881 60,62.158 60,60.05 L60,59.775 L60,54.25 L60,41.766 L60,40.006 L60,21.065 L60,8.374 L60,8.358 L59.999,8.358 Z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <use fill={fill} xlinkHref="#bus-a" />
      </g>
    </Icon>
  );
};

BusIcon.propTypes = {
  fill: PropTypes.string,
};

export default BusIcon;
